import Markdown from '../Markdown'
import LocalTime from './LocalTime'
import { Capacitor } from '@capacitor/core';
import { IonModal, IonContent, IonButton, IonInput, IonTextarea, IonIcon } from '@ionic/react';
import { useState } from 'react';
import tts from '@/components/Chat/TTS';
import { volumeHigh } from 'ionicons/icons';

export type Message = {
    id?: number,
    role: string;
    type: "text" | "image" | "audio",
    content: string;
    timestamp: string;
    first_token_time?: number; // time to first token
    total_reply_time?: number;
    num_tokens?: number;
    sent?: boolean;
    edited?: boolean;
    original?: string
};

// for easier debug, display all timings
const debug = false;//true;

function capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const Message = ({ msg }: { msg: Message }) => {
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    //const [editedText, setEditedText] = useState(msg.content);

    const handleSave = (e) => {
        setEditModalOpen(false);

        const form = e.target.closest("form");
        if (!msg.edited)
            msg.original = msg.content;

        msg.content = form['msg'].value;
        
        msg.edited = true;
        console.log(msg);
    };

    const submitChange = (e) => {
        e.preventDefault();
        handleSave(e);
    }

    const editorKeyDown = (e) => {
        if (e.key == "Enter" && !e.shiftKey) {
            console.log(e);
            e.preventDefault();
            //e.target.closest("form").submit();
            handleSave(e);
        }
    }

    return (
        <div
            className={`message ${msg.role} mb-2 m-auto max-w-5xl flex ${
                msg.role === "User" ? "justify-end" : "justify-start"
            }`}
        >
            <div className="group">
                <div className={`text-xs opacity-70 mb-1 flex ${
                    msg.role === "User" ? "justify-end" : "justify-start"
                }`}>
                    {msg.role === "User" ? "Student" : capitalize(msg.role)}
                </div>
                <div
                    className={`p-2 rounded m-auto max-w-2xl break-words ${
                        msg.role === "User"
                            ? "bg-blue-100 text-gray-900 dark:bg-slate-700 dark:text-white"
                            : "bg-gray-200 text-gray-900 dark:bg-gray-700 dark:text-gray-100"
                    }`}
                >
                    {msg.type === "text" && (<Markdown content={msg.content} />)}
                    {msg.type === "image" && (<img src={Capacitor.convertFileSrc(msg.content)} />)}
                    {msg.type === "audio" && (<audio controls src={Capacitor.convertFileSrc(msg.content)}></audio>)}
                </div>
                <div className={`flex ml-auto text-[10px] text-right group-hover:opacity-50 transition-opacity duration-200 items-center space-x-2 justify-end ${debug ? "" : "opacity-0"}`}>
                    <LocalTime utc={msg.timestamp} />

                    {/* {msg.first_token_time && (<div>ftt: {Math.round(msg.first_token_time / 1000)}s</div>)}
                    {msg.total_reply_time && (<div>trt: {Math.round(msg.total_reply_time / 1000)}s</div>)}
                    {msg.num_tokens && (<div>#tokens: {msg.num_tokens}</div>)}
                    {msg.total_reply_time && msg.num_tokens && (<div>rtpt: {Math.round(msg.total_reply_time / msg.num_tokens)}ms</div>)} */}
                    <IonButton 
                        size="small" 
                        onClick={() => setEditModalOpen(true)}
                        className="opacity-0 group-hover:opacity-50 transition-opacity duration-200"
                    >
                        Edit
                    </IonButton>
                    <button onClick={() => {tts.speak(msg.content)}} type="button" className="p-2 m-1 rounded-full hover:bg-gray-100 dark:hover:bg-zinc-800 flex items-center justify-center">
                        <IonIcon icon={volumeHigh} style={{ fontSize: '1.25rem', color: 'inherit' }} />
                    </button>
                </div>
                
                <IonModal 
                    isOpen={isEditModalOpen} 
                    onDidDismiss={() => setEditModalOpen(false)}
                >
                    <IonContent className="ion-padding">
                        <h2 className="ion-padding">Edit Message</h2>
                        <form className="ion-padding h-[80%] w-full" onSubmit={submitChange}>
                            <textarea
                                autoComplete='off'
                                name="msg"
                                defaultValue={msg.content}
                                onKeyDown={editorKeyDown}
                                //onChange={e => setEditedText(e.value!)}
                                className="ion-padding h-full w-full dark:bg-slate-700 p-3 rounded"
                            />
                            <div className="flex justify-end mt-4">
                                <IonButton type="submit">
                                    Save
                                </IonButton>
                            </div>
                        </form>
                    </IonContent>
                </IonModal>
            </div>
        </div>
    )
}
